// Branding por plataforma (Maxdream / Laketravel).
//
// La plataforma se resuelve en RUNTIME para poder cambiarla desde build/env.js
// (window.__MXD_ENV__.PLATFORM) SIN recompilar. Si env.js no la define, se usa
// la plataforma con la que se compiló (REACT_APP_PLATFORM) y, por defecto,
// Maxdream. Así un mismo build puede servir cualquiera de las dos marcas.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const envPlatform = (((window as any).__MXD_ENV__ || {}).PLATFORM || "") as string;
const raw = (envPlatform || process.env.REACT_APP_PLATFORM || "Maxdream").toString();

export const isLake = raw.toLocaleLowerCase() === "laketravel";

// Carpeta de assets (src/assets/images/<platformDir>/).
export const platformDir = isLake ? "laketravel" : "maxdream";
// Etiqueta para título de pestaña, favicon (<Label>.png) y manifest
// (manifest.<Label>.json) — coincide con los nombres de archivo en public/.
export const platformLabel = isLake ? "Laketravel" : "Maxdream";
// Nombre de marca para textos visibles (copyright, headers).
export const brandName = isLake ? "Lake Travel" : "Maxdream";
// Sitio institucional (link "Volver" del login).
export const homepage = isLake
  ? "https://laketravelcompany.com.ar/home/"
  : "http://maxdream.tur.ar";

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const logo: string = require(`../assets/images/${platformDir}/logo.png`);

type Tokens = { [cssVar: string]: string };

const TOKENS: Record<string, Tokens> = {
  maxdream: {
    "--primary-platform": "rgb(0,75,118)",
    "--color-dark-platform": "rgb(0,45,75)",
    "--color-bg-secondary": "#f7f8fc",
    "--color-text-base": "#fff",
  },
  laketravel: {
    "--primary-platform": "#bd291b",
    "--color-dark-platform": "#a32b20",
    "--color-bg-secondary": "#f7f8fc",
    "--color-text-base": "#fff",
  },
};

const DESCRIPTIONS: Record<string, string> = {
  maxdream: "Maxdream - Vivi dos viajes de egresados - Turismo Estudiantil",
  laketravel:
    "La empresa de viajes de egresados primarios y estudiantiles mas DIVERTIDA, SANA, SEGURA y CONFIABLE del país! #TenesQueVivirlo",
};

function setLink(rel: string, href: string): void {
  let el = document.head.querySelector(
    `link[rel="${rel}"]`
  ) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Aplica el branding de la plataforma: colores (tokens CSS en :root, que ganan
// sobre el stylesheet), título de pestaña, favicon, manifest y meta description.
// Llamar lo antes posible (index.tsx, antes del render) para evitar flashes.
export function applyBrand(): void {
  const tokens = TOKENS[platformDir] || TOKENS.maxdream;
  const root = document.documentElement;
  Object.keys(tokens).forEach((cssVar) =>
    root.style.setProperty(cssVar, tokens[cssVar])
  );

  const base = process.env.PUBLIC_URL || "";
  document.title = platformLabel;
  setLink("icon", `${base}/${platformLabel}.png`);
  setLink("manifest", `${base}/manifest.${platformLabel}.json`);

  const desc = document.head.querySelector('meta[name="description"]');
  if (desc) desc.setAttribute("content", DESCRIPTIONS[platformDir]);
}
